import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const forever = { staleTime: Infinity };

export const useCategories = () =>
  useQuery({ queryKey: ["categories"], queryFn: async () => (await api.get("/categories")).data, ...forever });

export const useConditions = () =>
  useQuery({ queryKey: ["conditions"], queryFn: async () => (await api.get("/conditions")).data, ...forever });

export const useLocations = () =>
  useQuery({ queryKey: ["locations"], queryFn: async () => (await api.get("/locations")).data, ...forever });

export const usePublicSettings = () =>
  useQuery({ queryKey: ["public-settings"], queryFn: async () => (await api.get("/settings/public")).data });

export function useCategory(slug) {
  const { data } = useCategories();
  return data?.find((c) => c.slug === slug);
}
